

// annoying to have to do a md_index but only way for good color and descriptions and all


export const workMdIndex = [
    {
        name: 'Software Developer Co-op',
        description: 'FreshBooks',
        color: '#0075dd',
        language: 'Toronto',
        link: '/md/work-experiences/FreshBooksSoftwareDev2026.md',
        updated: 'May 2026 - August 2026'
    },
    {
        name: 'Data Engineer Intern',
        description: 'Adknown Inc',
        color: 'orange',
        language: 'Guelph',
        link: '/md/work-experiences/AdknownDataDev2025.md',
        updated: 'September 2025 - December 2025'
    },
    {
        name: 'Software Developer Intern',
        description: 'Adknown Inc',
        color: 'orange',
        language: 'Guelph',
        link: '/md/work-experiences/AdknownSoftwareDev2025.md',
        updated: 'May 2025 - August 2025'
    },
    {
        name: 'Frontend Developer Intern',
        description: 'Ontario Lottery and Gaming Corporation',
        color: 'navy',
        language: 'Toronto',
        link: '/md/work-experiences/OLGFrontendDev2024.md',
        updated: 'May 2024 - August 2024'
    }
];

export const resume = {
    name: 'Aaron Amelink',
    description: '2026 Resume',
    color: 'navy',
    language: 'Guelph',
    link: '/pdf/resume/AaronAmelinkResumeSept2026.pdf',
    updated: 'September 2026'
};

export const fileIndex = [...workMdIndex, resume];
